export default __webpack_public_path__ + "static/media/2.b17bda5c.jpg";